import { APP_URL } from 'shared/constants';
import { GetRoutesFn, AdminRoute } from 'shared/routes/';

import { ReportsPage } from './pages/ReportsPage';

export const getAdminReportsRoutes: GetRoutesFn = () => [
  {
    routeComponent: AdminRoute,
    path: APP_URL.admin.reports.index,
    exact: true,
    component: ReportsPage,
  },
];
